/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import calendaricon from './calendar.svg';
import timeicon from './time.svg';
import DotComponent from '../../../ui/DotComponent';

// import * as styles from './index.styles';
import { get } from 'lodash';
import moment from 'moment';

class ThankYou extends SafePureComponent {
  safeRender() {
    const {
      fields,
      closeModal,
      stepsData,
      formSuccess,
      isModal,
      reTryBtn,
    } = this.props;

    console.log('zzz ThankYou', fields);

    const SuccessHeading = formSuccess
      ? get(fields, 'SuccessHeading.value', '')
      : get(fields, 'ErrorHeading.value', '');
    const SuccessText = formSuccess
      ? get(fields, 'SuccessText.value', '')
      : get(fields, 'ErrorText.value', '');
    const CloseButtonText = get(fields, 'CloseButtonText.value', '');
    const BookAgainText = get(fields, 'BookAgainText.value', '');
    const TryAgainText = get(fields, 'TryAgainText.value', '');

    const time = get(stepsData, 'step2.time', '');
    const date = get(stepsData, 'step2.date', '');
    return (
      <div className="thankyou_sec">
        <h3>
          {SuccessHeading}
          <DotComponent />
        </h3>

        <p>{SuccessText}</p>

        {formSuccess && (
          <React.Fragment>
            <div className="location-name">{stepsData.step0.solution}</div>

            <div className="schedule-on">
              <div className="date">
                <span>
                  <img src={calendaricon} alt="calendar" />
                </span>
                <span>
                  {date && moment(date, 'MM/DD/YYYY').format('D MMM')}
                </span>
              </div>
              <div className="hrline">
                <hr></hr>
              </div>
              <div className="time">
                <span>
                  <img src={timeicon} alt="time" />
                </span>
                <span>{time && time}</span>
              </div>
            </div>
          </React.Fragment>
        )}
        {!formSuccess && (
          <div className="close_btn">
            <button onClick={reTryBtn}>{TryAgainText}</button>
          </div>
        )}
        {isModal && (
          <div className="close_btn">
            <button onClick={closeModal}>{CloseButtonText}</button>
          </div>
        )}
        {formSuccess && !isModal && (
          <div className="close_btn">
            <button onClick={reTryBtn}>{BookAgainText}</button>
          </div>
        )}
      </div>
    );
  }
}

ThankYou.displayName = 'BookVisit/ThankYou';

export default compose(withNamespaces())(ThankYou);
